// extracted by mini-css-extract-plugin
export default {"description":"views_description__82uwn"};